import { useGLTF } from "@react-three/drei";
import { forwardRef } from "react";
import useSetMaterial from "../utils/useSetMaterial";

//region SingleCasementWindow
export function BuildingInterior({
}) {
  const { nodes, materials } = useGLTF("/models/building_interior.glb");

  console.log("nodes", nodes);
  console.log("materials", materials);

  useSetMaterial(materials.innerWall, "InnerWall");
  useSetMaterial(materials.ceiling, "Ceiling");
  useSetMaterial(materials.floor, "Floor");

  return (
    <group dispose={null} position={[0, 0, -0.0225]}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.CoffeeTable.geometry}
        material={materials.CoffeeTable}
      />
      <mesh castShadow receiveShadow geometry={nodes.Mat.geometry} material={materials.Mat} />
      <mesh castShadow receiveShadow geometry={nodes.Vase.geometry} material={materials.Vase} />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.PottedPlant.geometry}
        material={materials.PottedPlant}
      />
      <mesh castShadow receiveShadow geometry={nodes.decor1.geometry} material={materials.decor1} />
      <mesh castShadow receiveShadow geometry={nodes.decor2.geometry} material={materials.decor2} />
      <mesh castShadow receiveShadow geometry={nodes.Books.geometry} material={materials.Books} />
      <mesh castShadow receiveShadow geometry={nodes.Shelf.geometry} material={materials.Shelf} />
      <mesh castShadow receiveShadow geometry={nodes.Sofa.geometry} material={materials.Sofa} />
      <mesh castShadow receiveShadow geometry={nodes.floor.geometry} material={materials.floor} />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.innerBottom.geometry}
        material={materials.wallbottom}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.innerWalls.geometry}
        material={materials.innerWall}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.ceiling.geometry}
        material={materials.ceiling}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Painting1_1.geometry}
        material={materials.Painting1_1}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Painting1_2.geometry}
        material={materials.Painting1_2}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Painting1_3.geometry}
        material={materials.Painting1_3}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Painting1_4.geometry}
        material={materials.Painting1_4}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.RoofLamp_1.geometry}
        // material={materials.RoofLamp1}
      /> 
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.RoofLamp_2.geometry}
        material={materials.RoofLamp2}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.RoofLamp_3.geometry}
        material={materials.RoofLamp3}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Painting2_1.geometry}
        material={materials.Painting2_1}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Painting2_2.geometry}
        material={materials.Painting2_2}
      />
      <mesh castShadow receiveShadow geometry={nodes.Door_1.geometry} material={materials.Door1} />
      <mesh castShadow receiveShadow geometry={nodes.Door_2.geometry} material={materials.Door2} />
      <mesh castShadow receiveShadow geometry={nodes.Door_3.geometry} material={materials.Door3} />
      <mesh castShadow receiveShadow geometry={nodes.Door_4.geometry} material={materials.Door4} />
      <mesh castShadow receiveShadow geometry={nodes.Door_5.geometry} material={materials.Door5} />
      <mesh castShadow receiveShadow geometry={nodes.Door_6.geometry} material={materials.Door6} />
    </group>
  );
}

useGLTF.preload("/models/building_interior.glb");
